export default __webpack_public_path__ + "static/media/contact-bg.d2438f92.jpg";